"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETipoAdapta = void 0;
var ETipoAdapta;
(function (ETipoAdapta) {
    ETipoAdapta[ETipoAdapta["Adapta\u00E7\u00E3o"] = 1] = "Adapta\u00E7\u00E3o";
    ETipoAdapta[ETipoAdapta["Depend\u00EAncia"] = 2] = "Depend\u00EAncia";
    ETipoAdapta[ETipoAdapta["Complementa\u00E7\u00E3o"] = 3] = "Complementa\u00E7\u00E3o";
    ETipoAdapta[ETipoAdapta["Aproveitamento"] = 4] = "Aproveitamento";
})(ETipoAdapta = exports.ETipoAdapta || (exports.ETipoAdapta = {}));
